import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=3e784ea5&scoped=true"
import script from "./Authorized.vue?vue&type=script&lang=js"
export * from "./Authorized.vue?vue&type=script&lang=js"
import style0 from "./Authorized.vue?vue&type=style&index=0&id=3e784ea5&prod&lang=css"
import style1 from "./Authorized.vue?vue&type=style&index=1&id=3e784ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e784ea5",
  null
  
)

export default component.exports